export enum AuditLogAction {
  CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION',
  UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION',
  REDEEM_SUBSCRIPTION = 'REDEEM_SUBSCRIPTION'
}

export interface FilterAuditLogsParams {
  userId?: string;
  vendorId?: string;
  entityId?: string;
  action?: AuditLogAction;
  startDate?: string;
  endDate?: string;
  pageNumber: number;
  pageSize: number;
}

export interface AuditLog {
  id: string;
  action: string;
  entityType: string;
  entityId: string;
  userId: string;
  vendorId?: string;
  oldData?: any;
  newData?: any;
  metadata?: any;
  createdAt: Date;
}
